module.exports = __webpack_public_path__ + "img/1573846941.3310dd08.jpg";